import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { ethers, utils } from 'ethers'
import { getConvertCurrency, getTokenContract } from '../../api/common'
import { PROVIDER_NETWORKS } from '../../constant'
import { isEmpty, shorterAddress } from '../../utils'
import { MIN_ABI } from '../../utils/abi'
import clsx from 'clsx'
import { setAccounts, setChainId, setCryptoPayment, setTokenContract } from '../../redux/slices/common'
import SwitchNetwork from './SwitchNetwork'
interface Props {
  paymentMethods: Array<any>
  bookingPrices: any
}

let tempBalance: any = {}

const PayWithCrypto = ({ paymentMethods, bookingPrices }: Props) => {
  const dispatch = useAppDispatch()
  const { accounts, chainId, cryptoPayment, tokenContract } = useAppSelector((state) => state.common)
  const [balances, setBalances] = useState<any>({})
  // const [selectedCurrency, setSelectedCurrency] = useState<any>({})

  const paymentMethodCrypto: Array<any> = paymentMethods.filter((v) => v.type === 'CRYPTO')
  const paymentMethodCryptoEnabled: Array<any> = paymentMethodCrypto.filter((v) => {
    const isDisabled =
      (balances?.[v?.currency] && Number(balances[v?.currency] || 0) < bookingPrices?.finalPrice?.['USD']) ||
      !balances?.[v?.currency]
    return !isDisabled
  })
  useEffect(() => {
    if (
      !isEmpty(paymentMethodCryptoEnabled) &&
      !isEmpty(accounts) &&
      Object.keys(balances).length >= tokenContract.length
    ) {
      if (cryptoPayment) {
        // selected payment method before
        const itemActive = paymentMethodCryptoEnabled.find((v: any) => v?.currency === cryptoPayment)
        // console.log('itemActive', itemActive)
        if (!itemActive) {
          // const itCurrencySelect = paymentMethodCryptoEnabled.find((v: any) => v?.currency === selectedCurrency?.key)
          // dispatch(setCryptoPayment(itCurrencySelect?.currency || paymentMethodCryptoEnabled[0]?.currency))
          dispatch(setCryptoPayment(paymentMethodCryptoEnabled[0]?.currency))
        }
      } else {
        // not select payment method before
        // const itCurrencySelect = paymentMethodCryptoEnabled.find((v: any) => v?.currency === selectedCurrency?.key)
        // dispatch(setCryptoPayment(itCurrencySelect?.currency || paymentMethodCryptoEnabled[0]?.currency))
        dispatch(setCryptoPayment(paymentMethodCryptoEnabled[0]?.currency))
      }
    } else {
      dispatch(setCryptoPayment(''))
    }
    // eslint-disable-next-line
  }, [paymentMethods, paymentMethodCryptoEnabled])

  const getBalanceToken = async (tokenAddress: string, walletAddress: string) => {
    const provider = new ethers.providers.Web3Provider((window as any)?.ethereum)
    const contract = new ethers.Contract(tokenAddress, MIN_ABI, provider)
    return await contract.balanceOf(walletAddress)
  }
  const getBalanceNativeToken = async (walletAddress: string) => {
    const provider = new ethers.providers.Web3Provider((window as any)?.ethereum)
    const balance = await provider.getBalance(walletAddress)
    return balance
  }

  const fetchTokenContract = async () => {
    const networkItem = PROVIDER_NETWORKS.find((v) => v.hex === chainId)
    if (networkItem) {
      try {
        const res: any = await getTokenContract(networkItem?.decimal)
        if (res) {
          const result = (res || []).filter((v: any) => paymentMethodCrypto.find((el) => el.key === v.symbol))
          dispatch(setTokenContract(result))
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
  const fetchConvertCurrency = async (value: number | string, currency: string) => {
    try {
      const res = await getConvertCurrency(value, currency.toLowerCase())
      if (res) {
        tempBalance = {
          ...tempBalance,
          [currency]: Number(res['USD'] || 0).toFixed(2),
        }
        setBalances(tempBalance)
      }
    } catch (error) {
      console.log(error)
    }
  }
  const fetchBalancesAll = () => {
    tokenContract.forEach(async (el: any) => {
      if (el.address) {
        if (el.address?.startsWith('0x0')) {
          let balance = await getBalanceNativeToken(accounts[0] || '')
          fetchConvertCurrency(utils.formatUnits(balance.toString(), el?.decimal).toString(), el?.symbol)
        } else {
          let balance = await getBalanceToken(el.address, accounts[0] || '')
          fetchConvertCurrency(utils.formatUnits(balance.toString(), el.decimal).toString(), el.symbol)
        }
      }
    })
  }

  useEffect(() => {
    if (!isEmpty(tokenContract)) fetchBalancesAll()
    // eslint-disable-next-line
  }, [tokenContract])

  useEffect(() => {
    // if (chainId && !isEmpty(paymentMethodCrypto)) {
    if (chainId) {
      setBalances({})
      fetchTokenContract()
    }
    // eslint-disable-next-line
  }, [chainId, paymentMethods])
  useEffect(() => {
    if (window.ethereum && chainId) {
      window.ethereum.on('accountsChanged', (accounts: string[]) => {
        dispatch(setAccounts(accounts))
      })
      window.ethereum.on('chainChanged', async (newChainHex: string) => {
        if (chainId) dispatch(setChainId(newChainHex))
      })
    }
  }, [chainId])
  const renderCryptoPayment = (item: any) => {
    const isChecked = cryptoPayment === item.key
    const isDisabled = Number(balances[item.key] || 0) < bookingPrices?.finalPrice?.['USD']
    if (!tokenContract.find((el: any) => el?.symbol === item?.currency)) return null
    return (
      <div
        className={clsx(
          'flex justify-between w-full items-center',
          isChecked ? 'border-grayscale-900 border-[2px]' : 'border-[0.5px] border-[#00000026] hover:border-[1px]',
          isDisabled ? 'cursor-not-allowed opacity-[0.64]' : 'cursor-pointer opacity-100 hover:border-grayscale-900',
          'rounded-2xl p-[24px] radio-item-box'
        )}
        key={item.key}
        onClick={() => {
          if (!isDisabled) dispatch(setCryptoPayment(item.currency))
        }}
        role="presentation"
      >
        <div className='flex items-center'>
          <img src={item.icon} alt="" width={24} height={24} className='w-[24px] h-[24px] min-w-[24px]' />
          <span className='text-16-20 text-grayscale-900 font-inter-500 ml-[12px]'>{item.currency}</span>
        </div>
        {isDisabled ?
          <span className="text-14-18 text-grayscale-600 font-inter-400">
            {'Insufficient balance'}
          </span> :
          <div
            className={clsx(
              `radio-item w-6 h-6 min-w-[24px] rounded-full`,
              isChecked ? 'border-8 border-grayscale-900 radio-checked' : 'border-2 border-grayscale-300'
            )}
          />
        }
      </div>
    )
  }
  const label = process.env.REACT_APP_SUPPORT_CHAIN_ID === '0x13881' ? ' (Testnet)' : ''
  const isWrongNetwork = chainId !== process.env.REACT_APP_SUPPORT_CHAIN_ID
  return (
    <div>
      {accounts.map((el: string, idx: number) => {
        if (idx > 0) return null
        const network = PROVIDER_NETWORKS.find((v) => v.hex === chainId)
        return (
          <div className="flex items-start mt-[16px]" key={el}>
            <div
              className={clsx(
                'w-full border-[0.5px] text-14-18 text-grayscale-900 px-[24px] py-[14px] rounded-2xl flex items-center cursor-pointer',
                isWrongNetwork ? 'border-red-700' : 'border-[#00000026]',
              )}
            >
              <div
                className={clsx(
                  `w-[8px] h-[8px] rounded-[50%] mr-[8px] border`,
                  isWrongNetwork ? 'bg-red-200 border-red-700' : 'bg-forest-200 border-forest-700'
                )}
              />
              <div className="w-full flex flex-col font-inter-500">
                <span className={`uppercase text-12-16 ${isWrongNetwork ? 'text-red-700' : 'text-forest-700'}`}>
                  {network?.name}
                </span>
                <span className='text-12-16 text-grayscale-600'>{shorterAddress(el)}</span>
              </div>
            </div>
          </div>
        )
      })}

      {!isWrongNetwork ? (
        <div className='flex flex-col gap-2 my-2'>
          {(paymentMethodCrypto || []).map((el: any) => renderCryptoPayment(el))}
        </div>
      ) : (
        <div className="bg-red-100 py-[16px] px-[24px] rounded-xl flex flex-col items-start mt-[16px]">
          <p className="text-14-18 text-grayscale-600 font-inter-400 mb-[12px]">
            {`In order to transact on Dtravel, you’ll need to switch to Polygon${label}`}
          </p>
          <SwitchNetwork>
            <p
              className="w-full md:w-[auto] text-center md:text-left px-[12px] py-[8px] bg-red-700 rounded-lg text-white text-12-16 cursor-pointer font-inter-500 whitespace-nowrap"
            >
              Switch to Polygon{label}
            </p>
          </SwitchNetwork>
        </div>
      )}
    </div>
  )
}

export default PayWithCrypto
